<!-- <p>
  refund-status-in-progress works!!
</p> -->

<h1 class="h1-margin">{{pageData?.inprogress?.heading}}</h1>
<br>
<div>
  <a routerLink="/refund/status/lookup" > 
    << {{pageData?.inprogress?.backToSearch}} 
    <span aria-hidden="true"></span>
</a>
</div>
<br>

<!-- Unnamed (Rectangle) -->
<div id="calloutHeadingInfo" class="callout primary standard-margin-bottom"
aria-labelledby="calloutHeadingInfo">
  <h2 class="callout-padding text-gray" aria-live="assertive">{{pageData?.inprogress?.ccInfoHeading}}</h2>
  <p>{{pageData?.inprogress?.ccInfoMessage}}</p>
</div>
<br>
<!-- Unnamed (Rectangle) -->

<!-- Displaying only one Status per Ticket -->
<div class="card">
  <div class="card-section-padding">
    <div *ngIf="refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState !== null">
      <h2 class="h2-margin">{{pageData?.inprogress?.yourTripTo}} {{refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState}}</h2>
      <h3 id="cardHeadingId">{{refundStatusRs.refundStatus[0].scitDetails.sciUseDate | localizedDate:'fullDate' | capitalizeFirst}}</h3>
    </div>
    <div *ngIf="!refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].tripCreditInd === 'Y'">
      <h2 class="h2-margin">{{pageData?.inprogress?.tripCredit}}</h2>
    </div>
    <div *ngIf="!refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].tripCreditInd === 'N'">
      <div [ngSwitch]="refundStatusRs.refundStatus[0].productDescription">
        <div *ngSwitchCase="'INSTANT UPSELL'">
          <h2 class="h2-margin">{{pageData?.inprogress?.instantUpsell}}</h2>
        </div>
        <div *ngSwitchCase="'Prepaid Bags'">
          <h2 class="h2-margin">{{pageData?.inprogress?.prepaidBags}}</h2>
        </div>
        <div *ngSwitchCase="'Mileage Reinstatement Fee'">
          <h2 class="h2-margin">{{pageData?.inprogress?.mileReinstatementfee}}</h2>
        </div>
        <div *ngSwitchCase="'Group Deposits'">
          <h2 class="h2-margin">{{pageData?.inprogress?.groupDeposits}}</h2>
        </div>
        <div *ngSwitchDefault>
          <h2 class="h2-margin">{{pageData?.inprogress?.yourTrip}}</h2>
        </div>
      </div>
    </div>
    <div *ngIf="(!refundStatusRs.refundStatus[0].isTransportTicket || refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState === null) && refundStatusRs.refundStatus[0].tripCreditInd === null">
      <div [ngSwitch]="refundStatusRs.refundStatus[0].productDescription">
        <div *ngSwitchCase="'AWARD MAIN CABIN EXTRA'">
          <h2 class="h2-margin">{{pageData?.inprogress?.mainCabinExtra}} ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</h2>
        </div>
        <div *ngSwitchCase="'MAIN CABIN EXTRA'">
          <h2 class="h2-margin">{{pageData?.inprogress?.mainCabinExtra}} ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</h2>
        </div>
        <div *ngSwitchCase="'AWARD PREFERRED SEATS'">
          <h2 class="h2-margin">{{pageData?.inprogress?.preferredSeat}} ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</h2>
        </div>
        <div *ngSwitchCase="'PREFERRED SEATS'">
          <h2 class="h2-margin">{{pageData?.inprogress?.preferredSeat}} ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</h2>
        </div>
        <div *ngSwitchDefault>
          <h2 class="h2-margin">{{pageData?.inprogress?.yourTrip}}</h2>
        </div>
      </div>
      <br>
    </div>
    <!-- <br> -->
    <div class="card-section-background">
      <div class="card-section">
        <div class="grid-x grid-margin-x">
          <div class="cell small-6 align-text-left">
            <div *ngIf="refundStatusRs.refundStatus[0].tripCreditInd === 'Y'; else elseBlock"> 
              <b>{{pageData?.inprogress?.tripCreditNumber}} {{refundStatusRs.refundStatus[0].ticketNumber}}</b>
            </div>
            <ng-template #elseBlock>
              <b>{{pageData?.inprogress?.ticketNumber}} {{refundStatusRs.refundStatus[0].ticketNumber}}</b>
            </ng-template>
          </div>
          <div class="cell small-6 align-text-right padding-text-right">
            <span class="tag-info">&nbsp;&nbsp;{{pageData?.inprogress?.status}}&nbsp;&nbsp;</span>
          </div>
        </div>
        <br>
        <div class="grid-x grid-margin-x">
          <div *ngIf="!isEmailProvided" class="cell medium-6 large-8 align-text-left">
            {{pageData?.inprogress?.message}}
          </div>
          <div *ngIf="isEmailProvided" class="cell medium-6 large-8 align-text-left">
            {{pageData?.inprogress?.emailmessage}} <span class="link-blue">{{refundStatusRs.refundStatus[0].passengerContact.email | lowercase}}</span>.
          </div>
          <!-- <div class="cell medium-6 large-4 align-text-right padding-text-right"><span class="tag-success">&nbsp;&nbsp;{{pageData?.inprogress?.status}}&nbsp;&nbsp;</span></div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<br>
<div class="list-style standard-margin-bottom">
  <h3 id="refundHeading">{{pageData?.inprogress?.refundInformation}}</h3>
  <ul aria-labelledby="refundHeading">
    <!-- <li>{{pageData?.inprogress?.refundInformation1}}</li> -->
    <li>{{pageData?.inprogress?.refundInformation2}}</li>
    <li>{{pageData?.inprogress?.refundInformation3}}</li>
    <li>{{pageData?.inprogress?.refundInformation4}}</li>
  </ul>
</div>

<router-outlet></router-outlet>